
import React from "react";
import UserEvent from "../../core/UserEvent";
import reactjs from "../../core/reactjs";
import lang from "../../core/lang";
import numeral from "../../core/numeral";
import FileField from "../FileField";
import SelectField from "../SelectField";
import DateField from "../DateField";
import PropTypes from "prop-types";
import {FileDescriptor} from "../../core/fileIO";
import NumberField from "../NumberField";
import TextField from "../TextField";

function UniversalField(props) {
    const {type, value, name, label, helperText, placeholder, readOnly, disabled, required, debounce,
        className, variant, fullWidth, size,
        multiple, min, max, step, minLength, maxLength, pattern, color} = props;

    const handleChange = (event, value) => {
        let bounce;
        if(event instanceof UserEvent) {
            value = event.value;
            bounce = event.bounce;
        } else if(reactjs.isSyntheticEvent(event)) {
            value = event.currentTarget;
            // Native HTML form control-like
            const {currentTarget} = event;
            if(currentTarget.type==='number') {
                value = numeral.parse(currentTarget.value);
            } else {
                value = currentTarget.value;
            }
        } else if(lang.isPrimitive(event)) {
            value = event;
        }
        props.onChange && props.onChange(new UserEvent({value, bounce}, event));
    }

    const pointerEvents = (readOnly || disabled) ? 'none' : '';
    const opacity = disabled ? 0.7 : 1;
    const style = {opacity, ...props.style, pointerEvents};
    let field;

    if(type==='string' || type==='text') {
        const multiline = (type==='text')

        const inputProps = {minLength: minLength, maxLength: maxLength, pattern: pattern};
        field = <TextField name={name} value={value} onChange={handleChange}
                           label={label} placeholder={placeholder} helperText={helperText} color={color}
                           multiline={multiline} disabled={disabled} readOnly={readOnly} required={required} type={type}
                           className={className} style={style} variant={variant} size={size} fullWidth={fullWidth}
                           inputProps={inputProps} />
    } else if(type==='number') {
        field = <NumberField name={name} value={value} onChange={handleChange}
                             label={label} placeholder={placeholder} helperText={helperText} color={color}
                             disabled={disabled} readOnly={readOnly} required={required}
                             className={className} style={style} variant={variant} size={size} fullWidth={fullWidth}
                             min={min} max={max} step={step} />
    } else if(type==='date' || type==='datetime') {
        field = <DateField name={name} value={value} onChange={handleChange}
                           label={label} placeholder={placeholder} helperText={helperText} color={color}
                           disabled={disabled} required={required}
                           className={className} style={style} variant={variant} size={size} fullWidth={fullWidth}
                           minDate={min} maxDate={max} format={pattern} />
    } else if(type==='file' || type==='image') {
        const accept = (type==='image') ? 'image/*' : undefined;
        field = <FileField name={name} value={value} onChange={handleChange}
                           label={label} placeholder={placeholder} helperText={helperText}
                           multiple={multiple} disabled={disabled} readOnly={readOnly} required={required} accept={accept}
                           className={className} style={style} variant={variant} size={size} fullWidth={fullWidth} />
    } else if(lang.isArray(type)||type.indexOf('|')>0) {
        const options = lang.isArray(type) ? type : type.split('|');
        field = <SelectField name={name} value={value} onChange={handleChange} color={color}
                             label={label} placeholder={placeholder} helperText={helperText}
                             multiple={multiple} disabled={disabled} readOnly={readOnly} options={options} required={required}
                             className={className} style={style} variant={variant} size={size} fullWidth={fullWidth} />
    }

    return field;
}

UniversalField.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.oneOfType([
        PropTypes.oneOf(['string', 'text', 'number', 'date', 'file', 'image']),
        PropTypes.string,
        PropTypes.array
    ]),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.instanceOf(Date),
        PropTypes.array,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(FileDescriptor)
    ]),
    onChange: PropTypes.func,
    name: PropTypes.string,
    helperText: PropTypes.string,
    variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
    size: PropTypes.oneOf(['large', 'medium', 'small']),
    fullWidth: PropTypes.bool,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    multiple: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    pattern: PropTypes.string,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    color: PropTypes.string,
    debounce: PropTypes.bool
}

UniversalField.defaultProps = {
    format: "YYYY-MM-DD",
    variant: 'standard',
    debounce: false
}

export default UniversalField;